module.exports = __webpack_public_path__ + "static/media/ExoBNNVARA-Regular.cc1bb8ce.woff";